import loadable from '@loadable/component';
import { LoadingBalls } from '@moda/om';
import React from 'react';
import { useCart } from '../../hooks/useCart';
import { useCheckout } from '../../hooks/useCheckout';
import { useGiftExperienceFeatureFlag } from '../../hooks/useGiftExperienceFeatureFlag';

const CheckoutGiftSectionConfigurator = loadable(
  () => import('./CheckoutGiftSectionConfigurator'),
  {
    fallback: <LoadingBalls />,
    resolveComponent: exports => exports.CheckoutGiftSectionConfigurator
  }
);

export const CheckoutGiftSection = () => {
  const enabled = useGiftExperienceFeatureFlag();
  const {
    cart: {
      attributes: { isGiftingAllowed }
    }
  } = useCart();
  const { isShippingAddressSelected } = useCheckout();

  if (!enabled) return null;

  if (!isGiftingAllowed) return null;

  if (!isShippingAddressSelected) return null;

  return <CheckoutGiftSectionConfigurator />;
};
